export const TRANSLATION_KEYS = {
    Heading: "settingPage.customViewPage.heading",
    SecondaryHeading: "settingPage.customViewPage.secondaryHeading",
    BreadcrumbSettingHeading: "settingPage.heading",
    ColumnViewNameLabel: "settingPage.customViewPage.columnViewNameLabel",
    ColumnDepartmentLabel: "settingPage.customViewPage.columnDepartmentLabel",
    ColumnAssignedToLabel: "settingPage.customViewPage.columnAssignedToLabel",
    AssignedToLabelYes: "settingPage.customViewPage.assignedToLabelYes",
    AssignedToLabelNo: "settingPage.customViewPage.assignedToLabelNo",
    ColumnStatusLabel: "settingPage.customViewPage.columnStatusLabel",
    ColumnCreatedAtLabel: "settingPage.customViewPage.columnCreatedAtLabel",
    ColumnTimePeriodLabel: "settingPage.customViewPage.columnTimePeriodLabel",
    ColumnActionCommandUpdateLabel: "settingPage.customViewPage.columnActionCommandUpdateLabel",
    ColumnActionCommandUpdateTooltip: "settingPage.customViewPage.columnActionCommandUpdateTooltip",
    ColumnActionCommandDeleteLabel: "settingPage.customViewPage.columnActionCommandDeleteLabel",
    ColumnActionCommandDeleteTooltip: "settingPage.customViewPage.columnActionCommandDeleteTooltip",
    CommandCreateLabel: "settingPage.customViewPage.commandCreateLabel",
    CommandCreateTooltip: "settingPage.customViewPage.commandCreateTooltip",
    DetailsListEmptyContentLabel: "settingPage.customViewPage.detailsListEmptyContentLabel",
};